import { FaStar } from 'react-icons/fa';
import './TestimonialCard.css';

export default function TestimonialCard({ stars, desc, name }) {
  const starsEls = Array.from({ length: stars }, (_, i) => (
    <FaStar key={i} className='testimonial-stars' />
  ));

  return (
    <div className='testimonial-card'>
      <div>{stars ? starsEls : 'Number of Stars'}</div>
      <div className='test-desc'>{desc ? desc : 'Review Description'}</div>
      <div className='test-name'>{name ? name : 'Name of Reviewer'}</div>
    </div>
  );
}
